import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import FileSaver from "file-saver";
import { FarmerImportScreen } from "../../screen/FarmerImportScreen";
import Send from "../../core/communication";
import { customToast } from "../../components/Toast";
import { toast } from "react-toastify";
import { useScope } from "../SelectProjectCompanyContainer";
import { useSelector } from "react-redux";

export const FarmerImportContainer = forwardRef(({mobileForm = false, reloadData = () => {}}, ref) => {
  const { user } = useSelector(state => state.app.user);
  const { projectsByScope } = useScope();
  const [projectOptions, setProjectOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    if(isModalOpen) {
      setValues({});
      setCurrentTab(1);
    }
  }, [isModalOpen]);

  useEffect(() => {
    if(projectsByScope && projectsByScope?.length > 0) {
      const newOptions = projectsByScope?.filter(item => item)?.map(row => ({ value: row.id, label: row.description }));
      setProjectOptions(newOptions);
      setSelectedProject(newOptions[0]?.value);
    }
  }, [JSON.stringify({projectsByScope})]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setValues({});
  };
  
  // Expõe os métodos para serem chamados pelo componente pai
  useImperativeHandle(ref, () => ({
    handleOpenModal,
    handleCloseModal
  }));

  const handleChangeTab = (newTab) => {
    if(!Array.isArray(newTab)) {
      setCurrentTab(newTab.value);
    }
  }

  const handleChange = (name, value) => {
    if(name === 'project') {
      setSelectedProject(value?.value);
      return;
    };

    setValues(curr => ({ ...curr, [name]: value }));
  }

  const handleGetFileModel = async () => {
    setLoading(true);
    const toastId = toast.loading('Baixando modelo de importação');
    try {
      let response = await Send.post(`/uploadData/export`, {}, true, false);

      if(!response) {
        throw new Error(response);
      }
      
      response = await response.blob();
      FileSaver(response, "modelo_importação_usuarios");
      
      toast.update(toastId, {
        render: "Modelo disponível",
        type: "success",
        isLoading: false,
        autoClose: 2000
      });

    } catch(error) {
      toast.update(toastId, {
        render: "Erro ao baixar modelo de importação.",
        type: "error",
        isLoading: false,
        autoClose: 2000
      });
      console.log("Error", error);
    }

    setLoading(false);
  }

  const startUpload = async (data, toastId) => {
    try {
      const response = await Send.post(`/uploadData/startUploadData/${data.id}`, data);

      if(response.statusCode === 500) {
        handleCloseModal();
        reloadData()
        toast.update(toastId, {
          render: "Usuário(s) importado(s) com sucesso!",
          type: "success",
          isLoading: false,
          autoClose: 2000
        });
      } else if (!response.success) {
        throw new Error();
      }

      reloadData()
      toast.update(toastId, {
        render: "Usuário(s) importado(s) com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000
      });

    } catch(error) {
      toast.update(toastId, {
        render: "Erro ao importar usuário(s)",
        type: "error",
        isLoading: false,
        autoClose: 2000
      });
      console.log("Error")
    }
  }

  const handleUploadFile = async () => {
    if(!values['file'] || !selectedProject) {
      customToast('Preencha todas as informações', 'warning')
      return;
    }

    const toastId = toast.loading('Iniciando importação. Aguarde.');

    try {
      const response = await Send.post('/uploadData', {
        link: values['file'],
        userId: user.id,
        projectId: selectedProject,
        formId: '0',
        type: 1,
        status: 1
      });

      if(response) {
        await startUpload(response, toastId)
      } else {
        throw new Error('error');
      }

    } catch(error) {
      console.log("Error", error);
      toast.update(toastId, {
        render: "Erro ao importar usuário(s)",
        type: "error",
        isLoading: false,
        autoClose: 2000
      });
    }
  }

  const handleSaveUser = async () => {
    if(!values['email'] || !selectedProject) {
      customToast('Campo email ou projeto não informado', 'warning')
      return;
    }

    const toastId = toast.loading('Criando usuário. Aguarde.');

    try {
      const response = await Send.postOffline('/users/impactools', {
        ...values,
        projectId: selectedProject
      });

      if(response.statusCode === 500) {
        reloadData()
        toast.update(toastId, {
          render: "Usuário criado com sucesso.",
          type: "success",
          isLoading: false,
          autoClose: 2000
        });
      } else if(!response || response.status === 'error') {
        throw new Error();
      }
      reloadData()
      toast.update(toastId, {
        render: "Usuário criado com sucesso.",
        type: "success",
        isLoading: false,
        autoClose: 2000,
        position: "top-right"
      });
      
      // Sempre fechar o modal após salvar com sucesso
      handleCloseModal();
    } catch(error) {
      console.log("Error", error);
      toast.update(toastId, {
        render: "Erro ao criar usuário",
        type: "error",
        isLoading: false,
        autoClose: 2000
      });
    }
  }

  return <FarmerImportScreen
    isModalOpen={isModalOpen}
    tab={currentTab}
    handleOpenModal={handleOpenModal}
    handleCloseModal={handleCloseModal}
    handleChangeTab={handleChangeTab}
    handleGetFileModel={handleGetFileModel}
    loading={loading}
    values={values}
    selectedProject={selectedProject}
    projectOptions={projectOptions}
    handleChange={handleChange}
    handleSaveUser={handleSaveUser}
    handleUploadFile={handleUploadFile}
  />
});